import React, { useState, useEffect } from 'react';
import { Pagination } from "antd";
import Form from 'react-bootstrap/Form';

const InvestorResult = () => {


    const [resultData, setResultData]= useState ([
        {
            id:1,
            date:"",
            name:"Bhaskar",
            email:"bhaskar@theskepper.com",
            phone_num:987456123,
            question1:"How aligned do you feel with our brand’s mission and values?",
            question2:"What do you like most about our products or services?",
            question3:"What can we improve to meet your needs better?",
            question4:"How satisfied are you with our customer service?",
            question5:"Would you recommend our brand to others? Why or why not?",
            question6:"How often do you use our products or services?",
            question7:"What other products or services would you like us to offer?",
            question8:"How do you view the quality of our products compared to our competitors?",
            question9:"How do you prefer interacting with the brand?",
            question10:"How easy is it to find information about our products or services?",
            question11:"What motivates you to choose our brand over others?",
            question12:"What was your first impression of our brand, and has it changed over time?",
            question13:"Do you feel our brand values align with your personal values?",

        },
        {
            id:2,
            date:"",
            name:"Bhaskar",
            email:"bhaskar@theskepper.com",
            phone_num:987456123,
            question1:"How aligned do you feel with our brand’s mission and values?",
            question2:"What do you like most about our products or services?",
            question3:"What can we improve to meet your needs better?",
            question4:"How satisfied are you with our customer service?",
            question5:"Would you recommend our brand to others? Why or why not?",
            question6:"How often do you use our products or services?",
            question7:"What other products or services would you like us to offer?",
            question8:"How do you view the quality of our products compared to our competitors?",
            question9:"How do you prefer interacting with the brand?",
            question10:"How easy is it to find information about our products or services?",
            question11:"What motivates you to choose our brand over others?",
            question12:"What was your first impression of our brand, and has it changed over time?",
            question13:"Do you feel our brand values align with your personal values?",        },
        {
            id:3,
            date:"12/1/2023",
            name:"Bhaskar",
            email:"bhaskar@theskepper.com",
            phone_num:987456123,
            question1:"How aligned do you feel with our brand’s mission and values?",
            question2:"What do you like most about our products or services?",
            question3:"What can we improve to meet your needs better?",
            question4:"How satisfied are you with our customer service?",
            question5:"Would you recommend our brand to others? Why or why not?",
            question6:"How often do you use our products or services?",
            question7:"What other products or services would you like us to offer?",
            question8:"How do you view the quality of our products compared to our competitors?",
            question9:"How do you prefer interacting with the brand?",
            question10:"How easy is it to find information about our products or services?",
            question11:"What motivates you to choose our brand over others?",
            question12:"What was your first impression of our brand, and has it changed over time?",
            question13:"Do you feel our brand values align with your personal values?",        },
        {
            id:3,
            date:"12/1/2023",
            name:"Bhaskar",
            email:"bhaskar@theskepper.com",
            phone_num:987456123,
            question1:"How aligned do you feel with our brand’s mission and values?",
            question2:"What do you like most about our products or services?",
            question3:"What can we improve to meet your needs better?",
            question4:"How satisfied are you with our customer service?",
            question5:"Would you recommend our brand to others? Why or why not?",
            question6:"How often do you use our products or services?",
            question7:"What other products or services would you like us to offer?",
            question8:"How do you view the quality of our products compared to our competitors?",
            question9:"How do you prefer interacting with the brand?",
            question10:"How easy is it to find information about our products or services?",
            question11:"What motivates you to choose our brand over others?",
            question12:"What was your first impression of our brand, and has it changed over time?",
            question13:"Do you feel our brand values align with your personal values?",        },
        {
            id:3,
            date:"12/1/2023",
            name:"Bhaskar",
            email:"bhaskar@theskepper.com",
            phone_num:987456123,
            question1:"How aligned do you feel with our brand’s mission and values?",
            question2:"What do you like most about our products or services?",
            question3:"What can we improve to meet your needs better?",
            question4:"How satisfied are you with our customer service?",
            question5:"Would you recommend our brand to others? Why or why not?",
            question6:"How often do you use our products or services?",
            question7:"What other products or services would you like us to offer?",
            question8:"How do you view the quality of our products compared to our competitors?",
            question9:"How do you prefer interacting with the brand?",
            question10:"How easy is it to find information about our products or services?",
            question11:"What motivates you to choose our brand over others?",
            question12:"What was your first impression of our brand, and has it changed over time?",
            question13:"Do you feel our brand values align with your personal values?",        
          }
    ])


  return (
    <div className=''> 
            <div id="configtable" className="w-100 table-container pt-0 result_tab ">

                {
                       resultData.length>0 ? (
                            <table className=" responsive-table">
                            <thead>
                                <tr>
                                <th>Date</th>
                                <th>Name</th>
                                <th>Email Address</th>
                                <th>Phone Number</th>
                                <th>Question 1</th>
                                <th>Question 2</th>
                                <th>Question 3</th>
                                <th>Question 4</th>
                                <th>Question 5</th>
                                <th>Question 6</th>
                                <th>Question 7</th>
                                <th>Question 8</th>
                                <th>Question 9</th>
                                <th>Question 10</th>
                                <th>Question 11</th>
                                <th>Question 12</th>
                                <th>Question 13</th>


                                </tr>
                            </thead>
            
                                    <tbody>
                                        {/* <tr> */}
                                            {
                                            resultData.length > 0 && resultData.map((data)=>(
                                                <tr>
                                                {/* <td>{data.id}</td> */}
                                                <td>{data.date}</td>
                                                <td>{data.name}</td>
                                                <td>{data.email}</td>
                                                <td>{data.phone_num}</td>
                                                <td>{data.question1}</td>
                                                <td>{data.question2}</td>
                                                <td>{data.question3}</td>
                                                <td>{data.question4}</td>
                                                <td>{data.question5}</td>
                                                <td>{data.question6}</td>
                                                <td>{data.question7}</td>
                                                <td>{data.question8}</td>
                                                <td>{data.question9}</td>
                                                <td>{data.question10}</td>
                                                <td>{data.question11}</td>
                                                <td>{data.question12}</td>
                                                <td>{data.question13}</td>

                                                </tr>
                                                )
                                            )
                                             
                                            }
                                        {/* </tr> */}
                                    </tbody>
                               
                                
                         </table>
                        )
                         : 
                        (
                            <tr className='no_data'>
                            <td colSpan="8">No data available</td>
                            </tr>
                        )
                }


                
            </div>
            <div className='table_page'>
        <div className='one'>
          <span>Total: 10</span>
        </div>
        <div className='two'>
          <Pagination
            // current={zcurrentPage}
            // total="10"
            // pageSize=
            // onChange={zhandlePageChange}
          />
        </div>
        <div className='three'>
          <div className='show_page'>
            <p>Show Per Page</p>
            <div className='export_category'>
              <div className="select_category ">
                <Form.Select
                  aria-label="Show per page"
                //   value={zrowsPerPage}
                //   onChange={zhandleRowsPerPageChange}
                >
                  <option value="10">10</option>
                  <option value="20">20</option>
                  <option value="30">30</option>
                </Form.Select>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default InvestorResult